<template>
  <div id="app" ref="main">
    <headerTop></headerTop>
    <div class="img_top" v-if="btnFlag" @click="backTop"></div>
    <div class="empty" ref="empty">

    </div>
    <router-view />
    <footerBottom></footerBottom>
  </div>
</template>
<script>
import headerTop from "./components/headerTop.vue";
import footerBottom from "./components/footerBottom.vue";
export default {
  data() {
    return {
      // navButton:1,
      btnFlag: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
   
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
      
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },

    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
  },
  components: {
    headerTop,
    footerBottom,
  },
  watch: {
    $route(e, b) {
      // console.log(e,b)
     let height = window.getComputedStyle(this.$refs.empty).height;
     height=height.replace("px","")
     this.$store.state.scrollTop=height;
    //  console.log(height)
      if (e.path == "/Home/homelist") {
        document.documentElement.scrollTop = height;
      }
      if (b.path == "/"&&e.path != "/Home/homeItem1"&&e.path != "/Meeting/partyItem1"&&e.path != "/Service/fuWuItem1"&&e.path != "/About/contact") {
        document.documentElement.scrollTop = height;
      }
    },
  },
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.img_top {
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50%;
  background-image: url("./assets/image/to_top.png");
  background-size: 100% 100%;
  position: fixed;
  z-index: 999999999;
  top: 7.5rem;
  right:1rem;
  cursor: pointer;
}
.empty{
  width: 100%;
  height: 8.75rem;
   position: absolute;
    z-index: -1;
}

/* 约束屏幕尺寸 */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}
@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1024px;
  max-width: 1920px;
  /* max-height:1080px; */
  margin: 0 auto;
}
.el-carousel__indicator--horizontal {
  /* padding: 0 !important; */
  padding: 0px 0.125rem !important;
}
.el-carousel__button {
  width: 0.2125rem !important;
  height: 0.2125rem !important;
  border-radius: 50% !important;
}
.el-carousel__indicators--horizontal {
  bottom: 0.6625rem !important;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999999 !important;
}
.el-carousel__arrow {
  font-size: 0.625rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0) !important;
}
.el-carousel__arrow--left {
  left: 1.4375rem !important;
}
.el-carousel__arrow--right {
  right: 1.4375rem !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #40684b !important;
  color: #fff;
}
.small_icon {
  opacity: 0.5;
}
@font-face {  
  font-family: 'PingFang SC';  
  src: url('./assets/font/思源黑体.ttf'); 
  font-weight: normal;  
  font-style: normal;  
}
@font-face {  
  font-family: 'Myriad Pro';  
  src:url('./assets/font/MyriadPro-Regular.otf');
  font-weight: normal;  
  font-style: normal;  
}
@font-face {  
  font-family: 'Century Gothic';  
  src: url('./assets/font/GOTHIC.TTF');
  font-weight: normal;  
  font-style: normal;  
}

body{
	font-family: 'PingFang SC';
}
</style>
